import { render, staticRenderFns } from "./WorkingHouseBlContainerInfo.vue?vue&type=template&id=51a76ddb&scoped=true"
import script from "./WorkingHouseBlContainerInfo.vue?vue&type=script&lang=js"
export * from "./WorkingHouseBlContainerInfo.vue?vue&type=script&lang=js"
import style0 from "./WorkingHouseBlContainerInfo.vue?vue&type=style&index=0&id=51a76ddb&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a76ddb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51a76ddb')) {
      api.createRecord('51a76ddb', component.options)
    } else {
      api.reload('51a76ddb', component.options)
    }
    module.hot.accept("./WorkingHouseBlContainerInfo.vue?vue&type=template&id=51a76ddb&scoped=true", function () {
      api.rerender('51a76ddb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/WorkingHouseBlContainerInfo.vue"
export default component.exports